import { ReimbursementInput } from './interface';

export class GetAllRequests {
    static readonly type = '[Reimbursement] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateReimbursment {
    static readonly type = '[Reimbursement] create reimbursment';
    constructor(public input: ReimbursementInput) {}
}

export class SubmitReimbursment {
    static readonly type = '[Reimbursement] submit reimbursment';
    constructor(public input: { requestFormId: string; initiatorId: string }) {}
}

export class GetSingleReimbursmentRequest {
    static readonly type = '[Reimbursement] get-one';
    constructor(public id: string) {}
}
export class GetByUser {
    static readonly type = '[Reimbursement] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetApproverRequests {
    static readonly type = '[Reimbursement] approvers';
    constructor(public input: { id: string; query: string }) {}
}

export class DeleteReimbursment {
    static readonly type = '[Reimbursement] delete';
    constructor(public id: string) {}
}
export class ClearReimbursments {
    static readonly type = '[Reimbursement] Clear Reimbursments';
}
export class DeleteReq {
    static readonly type = '[Requests] get-approver';
    constructor(public id: string) {}
}
